import { SVGProps, Ref, forwardRef } from 'react';

export const FlBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M1 3.8A2.8 2.8 0 0 1 3.8 1h8.4A2.8 2.8 0 0 1 15 3.8v8.4a2.8 2.8 0 0 1-2.8 2.8H3.8A2.8 2.8 0 0 1 1 12.2z"
            fill="#00CD5E"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.153 5.218a.6.6 0 0 0-.039-.16.2.2 0 0 0-.06-.084.12.12 0 0 0-.076-.026H5.234a.4.4 0 0 0-.266.092q-.108.092-.108.3v5.55q-.001.051.031.09.043.046.103.064.095.03.194.04a2.8 2.8 0 0 0 .582 0 1 1 0 0 0 .195-.04.2.2 0 0 0 .103-.064.15.15 0 0 0 .028-.09V8.629h1.757a.12.12 0 0 0 .077-.026.2.2 0 0 0 .06-.088.6.6 0 0 0 .038-.156q.013-.117.012-.236 0-.13-.012-.26a.5.5 0 0 0-.038-.154.2.2 0 0 0-.06-.08.13.13 0 0 0-.077-.024H6.096V5.967h1.881q.044 0 .077-.028a.25.25 0 0 0 .06-.085q.03-.074.039-.153.012-.12.011-.24a2 2 0 0 0-.01-.243"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.19 10.333a.6.6 0 0 0-.043-.156.2.2 0 0 0-.07-.086.2.2 0 0 0-.1-.026h-1.622V5.101a.12.12 0 0 0-.036-.086.3.3 0 0 0-.121-.061 1.4 1.4 0 0 0-.226-.038 4 4 0 0 0-.357-.014q-.165-.002-.329.014-.116.01-.23.038a.3.3 0 0 0-.12.061.12.12 0 0 0-.037.086v5.603q0 .21.127.302a.52.52 0 0 0 .314.092h2.637q.055 0 .1-.029a.2.2 0 0 0 .07-.092.6.6 0 0 0 .042-.162q.03-.24 0-.48z"
            fill="white"
        />
    </svg>
));
FlBrandSize16Glyph.displayName = 'FlBrandSize16Glyph';
